import {WatchQueryOptions} from '@apollo/client';
import _ from 'underscore';
// eslint-disable-next-line import-x/no-extraneous-dependencies
import {Subscription} from 'zen-observable-ts';

import {getApolloClient} from 'graphql-client/ApolloClient';
import * as logging from 'util/Logging';

export default function initializeWatchQuery<TQuery>(
  queryOptions: WatchQueryOptions,
  onChange: (data: TQuery, loading: boolean) => void
): Subscription {
  const client = getApolloClient();
  return client.watchQuery<TQuery>(queryOptions).subscribe(({data, loading}) => {
    // Apollo queries can unexpectedly return undefined data, and we don't want callers to have to handle it.
    // isEmpty will catch falsey and {}
    if (_.isEmpty(data)) {
      logging.warn('Unexpectedly called subscription with empty object');
      return;
    }
    onChange(data, loading);
  });
}
